/* unplugin-vue-components disabled */import { render } from "./home.vue?vue&type=template&id=37192979"
const script = {}

import exportComponent from "G:\\code\\web\\cloud_live\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.47_webpack@5.77.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__